<template>
	<a-layout
		:class="['layout', `layout-${device}`, `layout-menu__${layoutMode}`]"
		:style="{ minHeight: '100vh' }"
	>
		<template v-if="isMobile">
			<a-drawer
				:visible="collapsed"
				:closable="false"
				placement="left"
				@close="() => this.collapsed = false"
				wrapClassName="drawer-sider"
			>
				<layout-sider :collapsed="false" :collapsible="false" @close="() => this.collapsed = false"></layout-sider>
			</a-drawer>
		</template>
		<layout-header :collapsed="collapsed" :style="{ left: '0px' }"></layout-header>
		<a-layout :style="{ paddingLeft: contentLeft }" class="layout-right">
			<template v-if="!isMobile && layoutMode === 'side'">
				<layout-sider :collapsed="collapsed"></layout-sider>
			</template>
			<a-layout-content
				:class="['layout-content', layoutMode === 'top' && `layout-content__${contentWidth}`]"
				:style="fixedHeader && {marginTop: '64px'}"
			>
				<!-- @click="$emit('toggle')" -->
      <span :title="collapsed ? '展开菜单' : '隐藏菜单'">
        <!-- <img v-if="showTrigger" src="../../../assets/images/ic_yc.png" :type="triggerIconType"  theme="filled"
        @click="toggle()" class="trigger" /> -->
        <a-icon v-if="showTrigger" class="trigger" :type="triggerIconType" @click="toggle()" />
      </span>
				<div class="layout-content--inner">
					<slot></slot>
				</div>
			</a-layout-content>

			<!-- <setting></setting> -->
		</a-layout>
    <div class="footer">
			<layout-footer></layout-footer>
		</div>
	</a-layout>
</template>

<script>
import LayoutSider from './LayoutSider'
import LayoutHeader from './LayoutHeader'
import LayoutFooter from './LayoutFooter'
// import Setting from '@/components/Setting'
import { appStoreMixin, deviceMixin } from '@/mixins'
import { DEVICE_TYPE } from '@/utils/device'

export default {
  name: 'Layout',
  components: {
    LayoutSider,
    LayoutHeader,
    LayoutFooter
    // Setting
  },
  mixins: [appStoreMixin, deviceMixin],
  data () {
    return {
      collapsed: false
    }
  },
  computed: {
    contentLeft () {
      return !this.fixedSiderbar || this.isMobile || this.layoutMode === 'top'
        ? 0
        : this.collapsed
          ? '0px'
          : '256px'
    },
    showTrigger () {
      return (
        this.layoutMode === 'side' ||
				(this.layoutMode === 'top' && this.isMobile)
      )
    },
    triggerIconType () {
      const flag = this.isMobile ? !this.collapsed : this.collapsed
      return flag ? 'double-right' : 'double-left'
    }
  },
  watch: {
    device: {
      immediate: true,
      handler (deviceType) {
        if (deviceType === DEVICE_TYPE.TABLET) {
          this.collapsed = true
        } else if (deviceType === DEVICE_TYPE.MOBILE) {
          this.collapsed = true
          setTimeout(() => {
            this.collapsed = false
          }, 60)
        } else {
          this.collapsed = false
        }
      }
    }
  },
  methods: {
    toggle () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  .layout-right {
    position: relative;
    box-sizing: border-box;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;

    .layout-content {
      width: 100%;
      // padding: 16px 16px 0;
      display: flex;

      .layout-content--inner {
        flex: 1 1 auto;
        width: 100%;
        position: relative;
      }
    }

    .layout-content::-webkit-scrollbar {
      display: none;
    }
  }

  .layout-content__fixed {
    max-width: 1200px;
    margin: 0 auto;
  }

  @media screen and (min-width: 1200px) {
    .layout-content__fixed {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }

  .trigger {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 500;
    transition: all 0.3s;
    font-size: 16px;
    padding: 12px 0;
    background: #a5a7ab;
    color: #fff;
    border-radius: 0 5px 5px 0;
  }

  .footer {
    position: fixed;
    bottom: 0px;
    width: 100%;
    pointer-events: none;
    background: white;
    padding: 5px 0;
  }
}
</style>
